import { inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-unificator/services';
import { COOKIE_ACCEPTED } from './user/data/cookie-names.data';
import { CookieToastComponent } from '../shared/components/toast/components/cookie-toast/cookie-toast.component';
import { ToastService } from '../shared/components/toast/toast.service';
import { GlobalEventsService } from './global-events.service';
import { delay, distinctUntilChanged, tap } from 'rxjs/operators';
import { ToastRef } from '../shared/components/toast/toast-ref';

@Injectable({
  providedIn: 'root',
})
export class CookieAcceptService {
  private _cookie = inject(CookieService);
  private _toast = inject(ToastService);
  private _events = inject(GlobalEventsService);
  private _cookieToast: ToastRef | null = null;

  public acceptCookie() {
    this._events.routerNavigationEnd$.pipe(
      distinctUntilChanged(),
      delay(0),
      tap(data => {
        const hideToastOnCurrentRoute = this._isCookieToastHiddenRoute(data?.url);
        if (hideToastOnCurrentRoute && this._cookieToast) {
          this._cookieToast.close();
          this._cookieToast = null;
        }
        if (!hideToastOnCurrentRoute && !this._cookie.check(COOKIE_ACCEPTED) && !this._cookieToast) {
          this._cookieToast = this._toast.info({component: CookieToastComponent}, {position: 'bottom-center', zIndex: 59});
        }
      })
    ).subscribe()
  }

  private _isCookieToastHiddenRoute(url: string): boolean {
    const hiddenCookieUrls = ['wallet=deposit', '403', '/play/', 'login', 'register', 'reset-password', 'forgot-password'];
    return hiddenCookieUrls.some(partUrl => url?.includes(partUrl));
  }

  public hideCookieToast() {
    if (this._cookieToast) {
      this._cookieToast.close();
      this._cookieToast = null;
    }
  }

  public showCookieToast() {
    if (!this._cookie.check(COOKIE_ACCEPTED) && !this._cookieToast) {
      this._cookieToast = this._toast.info({component: CookieToastComponent}, {position: 'bottom-center', zIndex: 59});
    }
  }

}
